import React, { createContext, useContext, useEffect, useState } from 'react';

export enum AppThemeEnum {
  light = 'light',
  dark = 'dark',
}

export enum BrandKit {
  ALX = 'ALX',
  FIT = 'FIT',
}

const ThemeContext = createContext({
  theme: AppThemeEnum.light as string,
  brandKit: BrandKit.ALX as string,
  toggleTheme: () => {},
});

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [theme, setTheme] = useState(
    localStorage.getItem('theme') || AppThemeEnum.light
  );

  const toggleTheme = () => {
    const newTheme =
      theme === AppThemeEnum.light ? AppThemeEnum.dark : AppThemeEnum.light;
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  useEffect(() => {
    if (theme === AppThemeEnum.dark) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [theme]);

  // White-labeling the UI kit.
  const brandKit = process.env['NX_BRANDING_KIT'] || BrandKit.ALX;

  useEffect(() => {
    if (brandKit === BrandKit.FIT) {
      document.body.classList.add('fit');
    }
  }, [brandKit]);

  return (
    <ThemeContext.Provider value={{ theme, brandKit, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
